import type { MonitoringResponse } from "@synthesis/shared-services/internal/monitoring/types";
import { MonitoringCard } from "./monitoring-card";
import { MonitoringMetric } from "./monitoring-metric";
import { MonitoringSectionHeading } from "./monitoring-section-heading";
import {
  getMonitoringMetrics,
  MONITORING_SECTION_TOOLTIPS,
  SYSTEM_FINANCE_METRICS,
  SYSTEM_PAYMENT_METRICS,
  SYSTEM_PRIMARY_METRICS,
} from "../monitoring-page.lib";

export const SystemStateSection = ({ railwayId, data }: { railwayId: string; data: MonitoringResponse }) => (
  <section className="flex flex-col gap-6">
    <MonitoringSectionHeading
      title="Состояние системы"
      tooltipTitle={MONITORING_SECTION_TOOLTIPS.system.title}
      tooltipDescription={MONITORING_SECTION_TOOLTIPS.system.description}
    />

    <MonitoringCard title="Основные показатели">
      <div className="flex gap-3">
        {getMonitoringMetrics(SYSTEM_PRIMARY_METRICS, railwayId, data).map((metric) => (
          <MonitoringMetric key={metric.id} metric={metric} />
        ))}
      </div>
    </MonitoringCard>

    <div className="flex gap-6">
      <MonitoringCard title="Условия оплаты" className="min-w-0 flex-1">
        <div className="flex gap-3">
          {getMonitoringMetrics(SYSTEM_PAYMENT_METRICS, railwayId, data).map((metric) => (
            <MonitoringMetric key={metric.id} metric={metric} />
          ))}
        </div>
      </MonitoringCard>

      <MonitoringCard title="Финансовые показатели" className="min-w-0 flex-[1.7]">
        <div className="flex gap-3">
          {getMonitoringMetrics(SYSTEM_FINANCE_METRICS, railwayId, data).map((metric) => (
            <MonitoringMetric key={metric.id} metric={metric} />
          ))}
        </div>
      </MonitoringCard>
    </div>
  </section>
);
